export default __webpack_public_path__ + "static/media/dashboard.8115f616.gif";